<template>
  <base-icon-button v-on="$listeners"
                    :title="title">
    <base-material-design-icon icon="add"/>
  </base-icon-button>
</template>

<script>
  import BaseIconButton from '@/components/base-components/base-icons/BaseIconButton';
  import BaseMaterialDesignIcon from '@/components/base-components/base-icons/BaseMaterialDesignIcon';

  export default {
    name: 'BaseIconButtonAdd',
    components: { BaseMaterialDesignIcon, BaseIconButton },
    props: {
      title: {
        type: String,
        default: 'Add',
        validator: (value) => value.length > 0,
      },
    },
  };
</script>

<style scoped>

</style>
